import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { Amount } from "models/utilTypes/currencyType";
import { ReceiptPaymentListProps } from "models/propTypes/paymentPropTypes";
import { ReceiptProfile, User } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import PaymentList from "../paymentListTable";

//#endregion
import cssExports from "theme/styles/main.module.scss";

const ReceiptList: React.FC<ReceiptPaymentListProps> = (props) => {
  return (
    <PaymentList
      properties={{
        createdPerson: {
          description: TranslationKeys.Common.Sender,
          formatter: (values: WintSuperkollAPIModel.ReceiptListItem) => new User(values.personId, values.personName),
          noWrap: true,
          width: "20%",
        },
        date: {
          description: TranslationKeys.Common.Date,
          formatter: (values: WintSuperkollAPIModel.ReceiptListItem) =>
            props.payout.date && new Date(props.payout.date),
          noWrap: true,
          width: "30%",
        },
        serialNumber: {
          formatter: (values: WintSuperkollAPIModel.ReceiptListItem) =>
            new ReceiptProfile(values.receiptId, values.serialNumber.toString()),
          description: TranslationKeys.Common.Number,
          className: cssExports.textBlue,
          alignment: "right",
          noWrap: true,
          width: "25%",
        },
        amount: {
          formatter: (values: WintSuperkollAPIModel.ReceiptListItem) =>
            values.amount && new Amount(values.amount.type, values.amount.value),
          description: TranslationKeys.Common.Amount,
          className: cssExports.textBlack,
          alignment: "right",
          width: "25%",
          noWrap: true,
        },
      }}
      disableRowSelection
      items={props.items ?? []}
      onRowSelectionsChange={props.onRowSelectionsChange}
    ></PaymentList>
  );
};

export default ReceiptList;
